var map = {
	"./80s_vaporwave.webp": 1613,
	"./ai_glitch_world.jpeg": 9742,
	"./ai_glitch_world.webp": 9905,
	"./airport.jpeg": 3472,
	"./airport.webp": 7475,
	"./analog_film.webp": 7447,
	"./anime.webp": 1372,
	"./art_gallery.jpeg": 4135,
	"./art_gallery.webp": 1772,
	"./balcony.jpeg": 9827,
	"./balcony.webp": 2660,
	"./barbiecore.webp": 5812,
	"./bathroom.jpeg": 2887,
	"./bathroom.webp": 8102,
	"./beach.jpeg": 40,
	"./beach.webp": 4391,
	"./beauty_profile.jpg": 6150,
	"./beauty_profile.webp": 734,
	"./bedroom.jpeg": 6691,
	"./bedroom.webp": 6812,
	"./bookstore.jpeg": 4097,
	"./bookstore.webp": 4630,
	"./cafe.jpeg": 4744,
	"./cafe.webp": 9637,
	"./canyons.jpeg": 742,
	"./canyons.webp": 5317,
	"./cartoon.webp": 1942,
	"./catalog.jpg": 399,
	"./catalog.webp": 1011,
	"./christmas_cabin.jpeg": 2269,
	"./christmas_cabin.webp": 1038,
	"./claymation.webp": 3817,
	"./comic.webp": 3957,
	"./coverpage.jpeg": 4335,
	"./coverpage.webp": 6748,
	"./cyberpunk.webp": 9509,
	"./cyberpunk_city.jpeg": 6880,
	"./cyberpunk_city.webp": 7329,
	"./desert.jpeg": 676,
	"./desert.webp": 6241,
	"./diwali_courtyard.jpeg": 7717,
	"./diwali_courtyard.webp": 1488,
	"./editorial.webp": 4645,
	"./european_street.jpeg": 6502,
	"./european_street.webp": 1269,
	"./forest.jpeg": 4528,
	"./forest.webp": 8425,
	"./ghibli.webp": 8723,
	"./glassmorphism.webp": 6073,
	"./graffiti_wall.jpeg": 2494,
	"./graffiti_wall.webp": 5337,
	"./indoor_studio1.jpg": 227,
	"./indoor_studio1.webp": 2629,
	"./indoor_studio2.jpeg": 3165,
	"./indoor_studio2.webp": 2872,
	"./kawaii.webp": 9458,
	"./kitchen.jpeg": 4699,
	"./kitchen.webp": 9732,
	"./lantern_street.jpeg": 587,
	"./lantern_street.webp": 1910,
	"./luxury_staircase.webp": 2615,
	"./meadow.jpeg": 4896,
	"./meadow.webp": 3753,
	"./minimal.webp": 3351,
	"./moroccan_riad.jpeg": 9868,
	"./moroccan_riad.webp": 6091,
	"./mountain.jpeg": 8350,
	"./mountain.webp": 9287,
	"./nature1.webp": 174,
	"./neon_alley.jpeg": 4151,
	"./neon_alley.webp": 4918,
	"./paper_cutout.webp": 4155,
	"./pixel_art.webp": 8746,
	"./poolside.jpg": 7423,
	"./poolside.webp": 5621,
	"./rainy_street.jpeg": 3052,
	"./rainy_street.webp": 3301,
	"./rampwalk.jpeg": 9644,
	"./rampwalk.webp": 9593,
	"./realistic.webp": 2372,
	"./retro.webp": 2604,
	"./retro_diner.jpeg": 1248,
	"./retro_diner.webp": 4067,
	"./roller_rink.jpeg": 8964,
	"./roller_rink.webp": 4611,
	"./rooftop.jpeg": 2754,
	"./rooftop.webp": 233,
	"./santorini_seaside.jpeg": 2911,
	"./santorini_seaside.webp": 192,
	"./snow.jpeg": 6510,
	"./snow.webp": 1495,
	"./sports.jpg": 1409,
	"./sports.webp": 9319,
	"./still_life.jpg": 5303,
	"./still_life.webp": 13,
	"./street_style.webp": 9773,
	"./street_vibe.webp": 4632,
	"./theatre_stage.jpeg": 2393,
	"./theatre_stage.webp": 6242,
	"./urban_architecture.webp": 4550,
	"./urban_garden.webp": 3860,
	"./vaporwave_gradient.jpeg": 3169,
	"./vaporwave_gradient.webp": 5483,
	"./warehouse.jpeg": 2812,
	"./warehouse.webp": 7551,
	"./warehouse_loft.jpeg": 2102,
	"./warehouse_loft.webp": 3307,
	"./workspace.jpeg": 2554,
	"./workspace.webp": 7029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8474;